// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeedLayout_wrapper__1kjBy","content":"FeedLayout_content__2dAPx","fullWidthWrapper":"FeedLayout_fullWidthWrapper__2mPoP","hide":"FeedLayout_hide__39NZH"};